// src/components/Header.jsx
import React from "react";
import { FiPhone, FiVideo, FiCloud, FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { createCall } from "../services/callService";
import "./Header.css";

const ADMIN_UID = "I41qVJFkMhUcs2j3Gl8ytQx6qx33";

export default function Header({ selectedChat, currentUser }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  if (!currentUser) return null;

  const receiverId = selectedChat?.uid;

  const openVeMeet = (e) => {
    e.preventDefault();
    if (!receiverId) return;
    window.open(
      `https://meet.vemeet.online/?room=${encodeURIComponent(receiverId)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const startAudioCall = async (e) => {
    e.preventDefault();
    if (!receiverId) return;
    await createCall({
      callerId: currentUser.uid,
      callerName: currentUser.displayName || "Unknown",
      receiverId,
      type: "audio",
    });
  };

  const startVideoCall = async (e) => {
    e.preventDefault();
    if (!receiverId) return;
    await createCall({
      callerId: currentUser.uid,
      callerName: currentUser.displayName || "Unknown",
      receiverId,
      type: "video",
    });
  };

  return (
    <header className="main-header fixed-header">
      <div className="header-left">
        <img
          src={selectedChat?.photoURL || "https://i.pravatar.cc/150"}
          alt="avatar"
          className="header-avatar"
        />
        <div className="header-contact-name">
          {selectedChat?.name || currentUser.displayName || "NUKKAD"}
        </div>
      </div>

      <div className="header-right">
        <button className="icon-btn" onClick={openVeMeet} disabled={!receiverId}>
          <FiCloud />
        </button>

        <button className="icon-btn" onClick={startAudioCall} disabled={!receiverId}>
          <FiPhone />
        </button>

        <button className="icon-btn" onClick={startVideoCall} disabled={!receiverId}>
          <FiVideo />
        </button>

        {currentUser.uid === ADMIN_UID && (
          <button
            className="icon-btn"
            onClick={() => navigate("/admin")}
            title="Admin Panel"
          >
            <FiUser />
          </button>
        )}

        <button className="icon-btn" onClick={logout}>🚪</button>
      </div>
    </header>
  );
}
